import {
  SERVICE_ADD_ON_DATA_LAYER_CATEGORY,
  SERVICE_PLAN_DATA_LAYER_CATEGORY,
  SETUP_CONNECTION_TYPE_FIELD_NAME,
  SETUP_MOBILE_NUMBER_OPTION_FIELD_NAME,
  SETUP_SECTION_ID,
} from 'journey/checkout/constants';
import {
  CheckoutCartBundle,
  CheckoutData,
  FormData,
  ProcessContext,
} from 'journey/checkout/types';

interface GetConnectionTypeValueParameter {
  bundle: CheckoutCartBundle;
  formData?: FormData;
  checkoutData?: CheckoutData;
}

export function getConnectionType(chooseNumberValue?: string | null) {
  const connections: { [key: string]: string } = {
    'Keep my current number': 'Port In',
    'Select a new number': 'New Connection',
  };
  return (
    chooseNumberValue !== undefined && {
      connectionType: connections[chooseNumberValue] || chooseNumberValue,
    }
  );
}

export function getFormData(checkoutData: CheckoutData, bundleId: string) {
  const setupSection = checkoutData.sections.find(
    (section) => section.sectionId === SETUP_SECTION_ID,
  );

  if (setupSection) {
    const steps = setupSection.steps.find(
      (step) => step.offerContainerId === bundleId,
    );

    if (steps) {
      return steps.entries.reduce(
        (entryObject, entry) => ({ ...entryObject, [entry.name]: entry.value }),
        {},
      );
    }
  }
  return {};
}

export function getConnectionTypeValue({
  bundle,
  formData = {},
}: GetConnectionTypeValueParameter): string | null {
  const { processContext, items } = bundle;
  const hasNewConnectionForPrepaidOrPostpaid =
    processContext === ProcessContext.NewOffer &&
    items.some(
      (x) =>
        x.dataLayerCategory === SERVICE_PLAN_DATA_LAYER_CATEGORY ||
        x.dataLayerCategory === SERVICE_ADD_ON_DATA_LAYER_CATEGORY,
    );

  switch (true) {
    case hasNewConnectionForPrepaidOrPostpaid:
      return (formData[SETUP_MOBILE_NUMBER_OPTION_FIELD_NAME] ||
        formData[SETUP_CONNECTION_TYPE_FIELD_NAME]) as string;
    case processContext === ProcessContext.ChangeOffer:
      return 'Change Plan';
    case processContext === ProcessContext.ModifyOffer:
      return 'Keep Telecom Number';
    default:
      return null;
  }
}
